import React, { Component, ReactNode } from 'react';
import './Reports.scss';
import { DashboardLayout } from '../../layouts/dashboard-layout/DashboardLayout';
import Alert from 'react-bootstrap/Alert';
import { SingleUser, UserAccountRoleEnum, UserRelationRoleEnum } from '../../api/types';
import { connect } from 'react-redux';
import { ApplicationState } from '../../app/store';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ReportsList, { EReportType } from './ReportsList';
import { ISplitLayoutItem, SplitSubLayout } from '../../layouts/split-sub-layouts/SplitSubLayout';
import { ERouterPath } from '../../features/router/ERouterPath';
import classNames from 'classnames';
import { Icon } from '../../features/icon/Icon';
import { IDossierV2 } from '../../models/DossierV2';
import { DossierMemberInterface } from '../../models/DossierMember';

interface DossierProps extends RouteComponentProps {
  dossier?: IDossierV2;
  dossierRelation?: DossierMemberInterface;
  dossierRelations?: DossierMemberInterface[];
  user?: SingleUser;
}

interface DossierState {
  selected?: EReportType;
  isActive?: boolean;
}

class Documents extends Component<DossierProps, DossierState> {
  state: DossierState = {};

  handleOpenPrivateDossier = (): void => this.setState({ selected: EReportType.PRIVATE, isActive: true });

  handleOpenPrivateClientDossier = (): void => this.setState({ selected: EReportType.PRIVATE_CLIENT, isActive: true });

  handleOpenSharedDossier = (): void => this.setState({ selected: EReportType.SHARED, isActive: true });

  renderMenuItem = (title: string, { isBackButton }: { isBackButton?: boolean } = {}): JSX.Element => (
    <div className={classNames('reports-menu-item', { 'reports-menu-item--back-button': isBackButton })} onClick={() => this.setState({ isActive: false })}>
      { isBackButton && <Icon className="reports-menu-item__back-icon" icon="back" />}
      <div className="reports-menu-item__title">{title}<Icon className="reports-menu-item__open-icon" icon="back" /></div>
    </div>
  );

  render(): ReactNode {
    const { dossier, dossierRelation, dossierRelations, user } = this.props;
    const { selected } = this.state;
    const isClient = dossierRelation?.role === UserRelationRoleEnum.client;
    const isParent = dossierRelation?.role === UserRelationRoleEnum.responsibleParty;
    const isCaregiver = dossierRelation?.role === UserRelationRoleEnum.caregiver;
    const isAdmin = user && [UserAccountRoleEnum.adminCaregiver, UserAccountRoleEnum.administration].includes(user.accountRole);

    const dossierContainsResponsible = dossierRelations?.some(relation => relation.role === UserRelationRoleEnum.responsibleParty);

    const defaults = { className: 'dossier__column-item' };
    const splitLayoutSidebarItems: ISplitLayoutItem[] = [];
    if (dossier && dossierContainsResponsible && (isCaregiver || isParent || isAdmin)) {
      const title = isParent ? 'Alleen zichtbaar voor u als ouder(s)' : 'Alleen zichtbaar voor ouder(s)';
      splitLayoutSidebarItems.push({
        ...defaults,
        routerPath: ERouterPath.reportsResponsible,
        element: this.renderMenuItem(title),
        mobileBackButtonElement: this.renderMenuItem(title, { isBackButton: true }),
        onSelect: this.handleOpenPrivateDossier,
      });
    }
    if (dossierContainsResponsible) {
      const isClientTitle = isClient ? 'Zichtbaar voor jou en je ouder(s)' : '';
      const isParentTitle = isParent ? 'Zichtbaar voor uw kind en u als ouder(s)' : '';
      const isCaregiverTitle = (isCaregiver || isAdmin) ? 'Zichtbaar voor cliënt en ouder(s)' : '';
      const title = isClientTitle || isParentTitle || isCaregiverTitle;
      splitLayoutSidebarItems.push({
        ...defaults,
        routerPath: ERouterPath.reportsShared,
        element: this.renderMenuItem(title),
        mobileBackButtonElement: this.renderMenuItem(title, { isBackButton: true }),
        onSelect: this.handleOpenSharedDossier,
      });
    }
    if (dossier && (isCaregiver || isClient || isAdmin)) {
      const title = isClient ? 'Alleen zichtbaar voor jou' : 'Alleen zichtbaar voor cliënt';
      splitLayoutSidebarItems.push({
        ...defaults,
        routerPath: ERouterPath.reportsClient,
        element: this.renderMenuItem(title),
        mobileBackButtonElement: this.renderMenuItem(title, { isBackButton: true }),
        onSelect: this.handleOpenPrivateClientDossier,
      });
    }

    return (
      <DashboardLayout grayBackgroundMobile={this.state.isActive}>
        <h1 className="page-title">Verslagen</h1>
        <SplitSubLayout items={splitLayoutSidebarItems} rootRouterPath={ERouterPath.reports} hideSidebarAndBackButton={splitLayoutSidebarItems.length <= 1 && !isCaregiver && !isAdmin}>
          { !selected && <Alert className="reports__info" variant="light">Nog geen categorie geselecteerd om de verslagen van in te zien</Alert> }
          {
            (selected && dossier) && <ReportsList dossierId={dossier.id} source={selected} isCaregiverOrAdmin={isCaregiver || isAdmin || false} />
          }
        </SplitSubLayout>
      </DashboardLayout>
    );
  }
}

export default connect((state: ApplicationState) => ({
  dossier: state.session.dossier,
  dossierRelation: state.session.relation,
  dossierRelations: state.session.dossierRelations,
  user: state.session.user,
}))(withRouter(Documents));
